module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_media":"This review does not have any attached photos or videos.","filtered_review_mismatch":"The selected review does not match the current filter. Showing the first review that matches the criteria.","filtered_review_none":"No reviews match the current filter. Please reset the filter and try again."}}')
  delete Component.options._Ctor
}
